/*
* @Author: Mark Miller
* @Date:   2018-08-29 23:18:31
* @Last Modified by:   msmiller
* @Last Modified time: 2019-12-15 14:29:23
*
* Copyright (c) 2017-2018 Sharp Stone Codewerks / Mark S. Miller
*/

import { Controller } from "stimulus"

export default class extends Controller {

    connect() {
      // console.log("-=> publish_controller connected");
    }

    initialize() {
      // console.log("-=> publish_controller initialized");

      $('#warnbutn').popup({});
    }

    load_modal(event) {
      var pubid = event.currentTarget.dataset.publishPubid;
      //console.log(pubid);
      $('#info_modal_body').load("/publish/" + pubid + "/info");
      $('#info_modal').modal('show');
    }


  };

// console.log("-=> publish_controller loaded");

